import { getUrl, Request } from "../../request";
import store from "../../../store";
export const postOrderSummary = (
    use_credit,
    city_id,
    discount_code,
    cart_items
) => {

    return new Promise((resolve) => { 
        setTimeout(() => {
            resolve({
                success: true,
                data: store.getState().Login.cart_data,
                code: 200
            })
        }, 200);
     })
    // return Request.post(getUrl("/api/v1/orders/order-summary/"), {
    //     use_credit,
    //     city_id,
    //     discount_code,
    //     cart_items,
    // });
};

export const postRequiredFields = (cart_items) => {
    return Request.post(getUrl("/api/v1/orders/required-fields/"), {
        cart_items,
    });
};

export const postPayment = (
    city_id,
    use_credit,
    discount_code,
    cart_items,
    first_name,
    last_name
) => {
    return Request.post(getUrl("/api/v1/orders/order/"), {
        city_id,
        use_credit,
        discount_code,
        cart_items,
        first_name,
        last_name,
    });
};

export const postReturnedSummary = (id, quantity) => {
    return Request.post(getUrl("/api/v1/orders/returned-summary/"), {
        id,
        quantity,
    });
};

export const postReturned = (id, quantity, poll_id) => {
    return Request.post(getUrl("/api/v1/orders/returned/"), {
        id,
        quantity,
        poll_id,
    });
};

export const postReturnedVerify = (id, code) => {
    return Request.post(getUrl("/api/v1/orders/returned-verify/"), {
        id,
        code,
    });
};

export const getReturnableOrders = () => {
    return Request.get(getUrl("/api/v1/orders/returnable/"));
};

export const getUserOrders = (id) => {
    return Request.get(getUrl("/api/v1/orders/user-orders/"), { id });
};
